module.exports = __webpack_public_path__ + "static/img/2_7.b2749ecd.jpg";